const DOMAIN0 = "https://testapi.quiktrak.co/";
const DOMAIN1 = "https://newapi.quiktrak.co/";
const DOMAIN2 = "https://helper.quiktrak.com.au/";
const DOMAIN3 = "https://test4.m2mdata.co/";
const DOMAIN4 = "https://nominatim.sinopacific.com.ua/";
const DOMAIN5 = "https://activation.gps-secure.co/";
const DOMAIN6 = "https://app.quikprotect.co/"
//const DOMAIN7 = "https://securetrack.co/"
const DOMAIN9 = "https://upload.quiktrak.co/";
const DOMIAN8 = "https://ss.sinopacific.com.ua/";

 
//https://helper.quiktrak.com.au/save-error/
export default {
	DOMAIN1,

	GO_FOR_ACTIVATION: DOMAIN5,
	GO_FOR_INSTALL_NOTICE: DOMAIN6,
	GET_WEBSITES: DOMAIN1 + 'QuikTrak/V1/Device/GetWebsitesOfAgent?Imei={0}',
	GET_PLAYBACK_ARR_WITHOUTADDRESSES: DOMAIN0 + "QuikTrak/V1/Device/GetHisPosArray2",
	LOGIN: DOMAIN1 + 'Quikloc8/V1/user/Auth2Testing',
	GET_ALERT_LIST: DOMAIN1 + 'QuikTrak/V1/Report/GetAlertList',
	GET_MONITORING_UNHANDLE_ALERTS: DOMAIN1 + 'QuikTrak/V2/Monitor/GetUnHandleAlerts?MajorToken={0}&MinorToken={1}',
	GET_MONITORING_HIS_ALERTS: DOMAIN1 + 'QuikTrak/V2/Monitor/GetHisAlerts?MajorToken={0}&MinorToken={1}&beginDate={2}&endDate={3}&alert={4}&imei={5}',
	HANDLE_ALERT: DOMAIN1 + 'Quiktrak/V2/Monitor/Handle',
	GET_TOP_ALARMS: DOMAIN1 + 'Quiktrak/V2/Monitor/AlarmOverView',

	ASSET_DEACTIVATE: DOMAIN1 + 'Common/V1/Activation/DeActivate',
	GET_ASSET_LIST: DOMAIN1 + 'QUIKTRAK/V2/ASSET/GETLIST?MajorToken={0}&MinorToken={1}&CsCode={2}&page={3}&rows={4}&sort={5}&order={6}&q={7}&SIMS={8}&AssetStatus={9}&AssetType={10}&payPlanCode={11}&Solution={12}&productCode={13}&SimStatus={14}&IMEIS={15}',
	GET_ASSET_INFO: DOMAIN1 + 'Common/v1/Activation/GetAssetsInfo',
	GET_ASSET_SSP: DOMAIN1 + 'Common/v1/Activation/SSP',
	GET_SYSTEM_COMMANDS: DOMAIN1 + 'QuikData/V1/Command/GetLIst2?MajorToken=${0}',

	EDIT_ASSET: DOMAIN1 + 'QuikTrak/V2/Asset/Edit',
	DELETE_ASSET: DOMAIN1 + 'Quiktrak/V2/Asset/Remove',
	RESET_MILEAGE: DOMAIN1 + 'Quiktrak/V2/Asset/ResetMileage',
	RESET_HOURS: DOMAIN1 + 'Quiktrak/V2/Asset/ResetLaunchHours',
	RESET_HISTORY: DOMAIN1 + 'Quiktrak/V2/Asset/ClearHistory',

	GET_USER_LIST: DOMAIN1 + 'QuikTrak/V2/User/GetList?MajorToken={0}&MinorToken={1}&CustomerCode={2}&page={3}&rows={4}&sort={5}&order={6}&RoleCode={7}&Q={8}',
	HANDLE_USER: DOMAIN1 + 'QuikTrak/V2/User/Handle',
	DELETE_USER: DOMAIN1 + 'QuikTrak/V2/User/Remove',
	ENABLE_USER: DOMAIN1 + 'QuikTrak/V2/User/Enable',
	DISABLE_USER: DOMAIN1 + 'QuikTrak/V2/User/Disable',

	GET_USER_INFO: DOMAIN1 + 'QuikTrak/V1/User/GetUserInfo',
	GET_DASHBOARD: DOMAIN1 + 'Quiktrak/v1/Report/Dashboard',
	GET_USAGE_OVERVIEW: DOMAIN1 + 'Quiktrak/v1/Report/UsageOverview',
	GET_TOP_USAGE: DOMAIN1 + 'Quiktrak/v1/Report/TopUsage2',
	GET_SOLUTIONS_AND_PRODUCTS: DOMAIN1 + 'Common/V1/Activation/SSP',

	RENEWAL: DOMAIN2 + 'Common/V1/Activation/Renewal',
	CREATE_CREDITS_PAYMENT: DOMAIN2 + 'stripe/dashboard-credit-recharge/create.php',
	ADD_CREDITS: DOMAIN2 + 'stripe/dashboard-credit-recharge/add-credits.php',
	CREDITS_TRANSFER: DOMAIN1 + 'Quiktrak/V1/Credits/Transfer',
	CREDITS_TRANSFER_HISTORY: DOMAIN1 + 'Quiktrak/V1/Credits/History',
	CREDITS_ON: DOMAIN1 + 'Tools/TurnOnCredits',
	CREDITS_OFF: DOMAIN1 + 'Tools/TurnOffCredits',
	URL_GET_CREDIT: DOMAIN1 + 'Installer/V1/Client/GetCredit',
 
	SAVE_ERROR: DOMAIN2 + "save-error/",
	SEND_ERROR_EMAIL: DOMAIN2 + "send-error-email/",
	SEND_INSURANCE_CERTIFICATE: DOMAIN2 + "send-insurance-certificate/",

	GET_CUSTOMERS: DOMAIN1 + 'Quiktrak/V2/Customer/GetList',
	QUERY_CUSTOMERS: DOMAIN1 + 'Quiktrak/V1/User/QueryAcccount',
	GET_PRE_EDIT_CUSTOMER_INFO: DOMAIN1 + 'Quiktrak/V2/Customer/PreEdit',
	GET_TOP_CUSTOMERS_BY_UNITS: DOMAIN1 + 'QuikTrak/V2/Report/TopUnitsByCustomer',
	GET_TOP_AGENTS_BY_CUSTOMERS: DOMAIN1 + 'QuikTrak/V2/Report/TopAgentsByCustomer',
	CUSTOMER_RESET_PASSWORD: DOMAIN1 + 'Quikloc8/V1/SubDealer/ResetPassword',
	CUSTOMER_DELETE: DOMAIN1 + 'Quiktrak/V2/Customer/Remove',
	CUSTOMER_DISABLE: DOMAIN1 + 'Quiktrak/V2/Customer/Disable',
	CUSTOMER_ENABLE: DOMAIN1 + 'Quiktrak/V2/Customer/Enable',
	CUSTOMER_EDIT: DOMAIN1 + 'Quiktrak/V2/Customer/Edit',
	SEND_CUSTOMER_REG_LETTER: DOMAIN1 + 'Common/V1/Activation/DealerRegistion',
	SEND_ASSET_ACTIVATION_LETTER: DOMAIN1 + 'Common/V1/Activation/ReSendActivation',

	GET_ASSET_LOCATION: DOMAIN1 + 'Installer/V1/Client/LivePostion',
	GET_ADDRESS_BY_COORDS: DOMAIN4 + 'reverse',
	//GET_SMS_HISTORY: DOMAIN1 + 'Installer/V1/Client/GetCommandHisMessages',
	GET_SMS_HISTORY: DOMAIN3 + 'JT/SMS/History',
	GET_TCP_HISTORY: DOMAIN1 + 'Quikdata/V1/SMS/GetHistory?from={0}&to={1}&numbers={2}',
	GET_SESSION_DATA: DOMAIN3 + 'JT/Sim/GETSESSIONS',
	GET_CURRENT_SESSION: DOMAIN3 + 'JT/SIM/GetActiveSession',
	GET_HLR: DOMAIN3 + 'JT/SIM/GetHlrInfo',//?imsi=${query.IMSIs}
	FORCE_RECONNECT: DOMAIN3 + 'JT/Sim/Reboot',//?imsi=${query.IMSIs}

	SIM_GET_SERVICE_PROFILE_OPTIONS: DOMAIN3 + 'JT/ServiceProfile/Query',
	SIM_SET_SERVICE_PROFILE: DOMAIN3 + 'JT/Sim/SetSimServiceProfile',
	SIM_SET_ACTIVATE: DOMAIN3 + 'JT/Sim/Activate',
	SIM_SET_SUSPEND: DOMAIN3 + 'JT/Sim/Suspend',
	SIM_SET_RESUME: DOMAIN3 + 'JT/Sim/Resume',
	SIM_SET_TERMINATE: DOMAIN3 + 'JT/Sim/Terminate',
	SIM_REPLACE: DOMAIN1 + 'Common/V1/Activation/ReplaceSim',
	SIM_SEND_COMMAND: DOMAIN1 + 'QuikData/V1/Command/SendByType',
	SIM_SEND_COMMAND_BY_TCP: DOMAIN1 + 'QuikData/V1/Command/SendByTypeViaTcp',

	//SIM_SEND_COMMAND: DOMAIN1 + 'Quikdata/v1/Command/SendByType2',
	SIM_GET_COMMANDS: DOMAIN1 + 'QuikData/V1/Command/GetCommandTypeList4Clients',
	SIM_GET_COMMANDS_TYPES: DOMAIN1 + 'Quiktrak/V2/Product/CommandTypes',
	TRANSFER_TO_CUSTOMER: DOMAIN1 + 'QuikTrak/V2/Asset/Transport2Customer',
	IMPORT_ASSETS: DOMAIN1 + 'QuikTrak/V2/Asset/Import',
	GET_ASSET_CSP: DOMAIN3 + 'JT/ServiceProfile/Query',
	GET_SIM_LIST: DOMAIN3 + 'JT/Sim/Query',

	GET_ACTIVATION_HISTORY: DOMAIN1 + 'COMMON/V1/ACTIVATION/QueryHistory',


	GET_QUERY_PARAMETERS: DOMAIN1 + 'Quiktrak/V2/monitor/GetQueryParameters?MajorToken={0}',
	GET_TOP_ALARMS: DOMAIN1 + 'Quiktrak/V2/monitor/AlarmOverView/',
	GET_ALARM_STATISTICS: DOMAIN1 + 'Quiktrak/V2/monitor/MonitorProfile',


	PHOTO_UPLOAD: DOMAIN9 + 'image/Upload',


 	SAVE_DOMAIN: DOMAIN1 + 'QuikTrak/v2/Domain/Save',	
	DELETE_DOMAIN: DOMAIN1 + 'QuikTrak/v2/Delete',
	GET_DOMAIN_LIST: DOMAIN1 + 'QuikTrak/v2/Domain/GetList?MajorToken={0}&MinorToken={1}',
	GET_REPORT_BY_ALERT: DOMAIN1 + 'QuikTrak/V1/Report/GetAlertReportDataV3',
 
	GET_ASSETS_LOCATION: DOMAIN0 + 'QuikTrak/V1/Device/GetPosInfosDB?MajorToken={0}&MinorToken={1}',
	LOGOUT: DOMAIN1+'QuikProtect/V1/Client/Logoff',
 


	 GET_REPORT_TRIP: DOMAIN0 + "QuikTrak/V1/Report/GetTripReport2New1",
   GET_REPORT_TRIP2: DOMAIN0 + "QuikTrak/V1/Report/GetTripReport2New",
	 GET_ADDRESSES_FROM_ARRAY: DOMIAN8 + "geocode/reverse/v1",

	GET_PLAYBACK_ARR_OPTIMISED: "https://osrm.sinopacific.com.ua",
	GET_PLAYBACK_ARR_OPTIMISED2: "https://osrm.sinopacific.com.ua/playback/v2",	
	  


	//GET_VIDEO_SCREEN: DOMAIN7 + '808gps/open/player/video.html'
}

//https://newapi.quiktrak.co/COMMON/V1/aCTIVATION/QueryHistory
//https://newapi.quiktrak.co/Common/V1/Activation/DealerRegistion
//http://newapi.quiktrak.co/Common/V1/Activation/SSP
//https://newapi.quiktrak.co/QuikData/V1/Command/SendByType


 
